import releaseManifest from '../../../release.json';

export const APP_NAME = 'Sentra CTEM';
export const APP_VERSION = import.meta.env['VITE_APP_VERSION'] || releaseManifest.version;
export const TG_USERNAME_LINK = 'https://t.me/sentra_ctem_support_bot';
export const DOCS_URL = 'https://docs.ctem.sentra-tech.ru/';
export const MOBILE_BREAKPOINT = 480;
export const TABLET_BREAKPOINT = 886;
